import React from 'react'
import TableLayout from '../../components/TableLayout'

const CustomerTypesListContainer = () => {
    const columns = [
        {
            title: 'Nombre',
            dataIndex: 'name',
            sorter: true,
            filtered: true,
        },
        {
            title: 'Porcentaje de venta',
            dataIndex: 'percent_value',
            sorter: true,
            render: (label, row) => {
                if (row.percent_value !== null) {
                    return <span>{`${row.percent_value}%`}</span>
                }
                return null
            },
        },

        {
            title: 'Creación',
            dataIndex: 'created_at',
            sorter: true,
            filtered: true,
        },
        {
            title: 'Actualizacíón',
            dataIndex: 'updated_at',
            sorter: true,
            filtered: true,
        },
        {
            title: 'Acciones',
            dataIndex: 'actions',
        },
    ]

    return (
        <>
            <TableLayout
                title="Listado de tipo de precio"
                columns={columns}
                resource="customer_types"
                actions={['excel', 'pdf', 'active', 'edit', 'show']}
            />
        </>
    )
}

export default CustomerTypesListContainer
